import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import Entity from '../Common/Entity';
import CreatePayment from './CreatePayment';
import PaymentHistory from './PaymentHistory';

const Payment = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          p: { xs: 2, md: 0 },
          mr: { xs: 0, md: 4 },
          ml: { xs: 0, md: 2 },
          position: { xs: 'sticky', md: 'relative' },
          top: 0,
          zIndex: 1000,
          boxShadow: { xs: '0px 2px 8px 0px #0000001A', md: 'none' },
          background: { xs: '#FAFAFA', md: 'transparent' },
        }}
      >
        <Entity
          entityLabel='SAP Code*'
          showEntitySelect={true}
          forceRefresh={true}
          gridSizes={{
            entity: { xs: 12, sm: 6, md: 4 },
          }}
        />
      </Box>
        <Box sx={{ p: { xs: 2, md: 3 } }}>
      <Grid
        container
        spacing={2}
        mb={3}

      >
        <Grid
          item
          xs={12}
        >
          <CreatePayment />
        </Grid>
          <Grid
          item
          xs={12}
        >
          <PaymentHistory />
        </Grid>
  
      </Grid>
      </Box>
    </>
  );
};

export default Payment;
